// extracted by mini-css-extract-plugin
module.exports = {"zone":"DropTarget_zone__m2SEZ","Draggable":"DropTarget_Draggable__1E4er","drag-content":"DropTarget_drag-content__yab5e","time":"DropTarget_time__2p1o-"};